import { render, staticRenderFns } from "./KcSeriesMatches.vue?vue&type=template&id=0ab5fa5a&scoped=true&"
import script from "./KcSeriesMatches.vue?vue&type=script&lang=ts&"
export * from "./KcSeriesMatches.vue?vue&type=script&lang=ts&"
import style0 from "./KcSeriesMatches.vue?vue&type=style&index=0&id=0ab5fa5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5fa5a",
  null
  
)

export default component.exports